// Builds the ABC notation clef modifier for a K: header line.
// https://abcnotation.com/wiki/abc:standard:v2.1#kkey
export const abcClefModifier = (clef = 'g') => clef === 'f' ? 'clef=bass' : 'clef=treble';

// abcjs's own note "pitch" unit (from abcjs.parseOnly()'s note elements) is
// diatonic — 7 per octave, 0 = middle C/C4, ignoring accidentals — which is
// exactly the "how many ledger lines" measure we need to judge playable range,
// but it's measured against the raw, untransposed source (abcjs only applies
// visualTranspose at render time, after parsing).
const BASS_CLEF_SHIFT_SEMITONES = -24; // two octaves, matches the shift in notes.js/abc-notation.js
const LOWEST_BASS_CLEF_PITCH = -12; // E2 — the first ledger line below the bass staff

// Given the raw (untransposed) diatonic pitches of every note abcjs parsed
// out of a tune, returns the semitone visualTranspose offset that puts it in
// bass-clef range: two octaves down, or just one if two would push the
// lowest note under the instrument's practical floor.
export const bassClefOctaveShiftSemitones = (pitches) => {
  if (pitches.length === 0) return BASS_CLEF_SHIFT_SEMITONES;
  const shiftedMinPitch = Math.min(...pitches) - 14; // 14 = 2 octaves in diatonic units
  return shiftedMinPitch < LOWEST_BASS_CLEF_PITCH
    ? BASS_CLEF_SHIFT_SEMITONES + 12 // too low — pull back up one octave
    : BASS_CLEF_SHIFT_SEMITONES;
};
